<template>
  <div>    
    <el-select
      v-close-on-zoom
      :value="state.vertebrae"
      placeholder="Any vertebra"
      class="vertebrae-select"
      :disabled="readonly"
      :multiple="true"
      @input="(vertebrae) => setVertebrae(vertebrae)"
    >
      <el-option
        v-for="vertebra in availableVertebrae"
        :key="vertebra.key"
        :label="vertebra.label.en"
        :value="vertebra.key"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';
import vertebrae from '~lib/common/config/vertebrae';

export default {
  name: 'spinal-assessment-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      vertebrae,
      state: {
        vertebrae: [],
      },
    };
  },
  computed: {
    availableVertebrae() {
      return vertebrae.filter(vert => {
        return this.spinalAssessments.find(caseVert => caseVert.key === vert.key);
      });
    },
    spinalAssessments() {
      const { caseConf } = this.emitter;
      return caseConf.spinalAssessments || [];
    },
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.vertebrae = get(data, 'vertebras') || [];
    this.update();
  },
  methods: {
    setVertebrae(vertebrae) {
      this.state.vertebrae = vertebrae;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'SPINAL_ASSESSMENT',
        id: 'SPINAL_ASSESSMENT',
        vertebras: this.state.vertebrae,
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>